import Layout from "../components/Layout";

function Regelwerke() {
  return (
    <Layout>
      <h1>Regelwerke</h1>
    </Layout>
  );
}

export default Regelwerke;